module.exports = __webpack_public_path__ + "downloads/DataSourceSpecificIndicator.95ef7c3b.xlsx";